import { withCompInfo } from '@wix/editor-elements-integrations'
import { AppWidgetPropsCSSVars, AppWidgetDefinition } from './AppWidget'
import { getHeightCSS } from '@wix/editor-elements-common-utils'

export const css = withCompInfo<AppWidgetPropsCSSVars | {}, AppWidgetDefinition>()(
	['skin', 'compLayout', 'compSingleLayout'],
	({ skin, compLayout, compSingleLayout }) => {
		const height = getHeightCSS(compLayout, compSingleLayout)
		return skin === 'AppWidgetLoaderSkin' ? { height } : {}
	}
)
